import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper/Paper';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import createStyles from '@material-ui/core/styles/createStyles';
import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles';
import GroupIcon from '@serko/zui-icons/es/GroupIcon';
import Typography from '@serko/zui/es/Typography';
import React, { FunctionComponent } from 'react';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import pure from 'recompose/pure';
import messages from '../intl/messages';
import { AppState } from '../store/model';
import { getTravellerNames } from '../store/reducers/itinerary/selectors';
import { spacings } from './lab/spacings';

interface StateProps {
  travellers: string[];
}

interface TravellerInfoProps
  extends StateProps,
    WithStyles<typeof styles>,
    InjectedIntlProps {}

const TravellerInfoBase: FunctionComponent<TravellerInfoProps> = ({
  classes,
  travellers,
  intl,
}) => {
  return (
    <Paper className={classes.container} square>
      <Grid container spacing={16} wrap="nowrap">
        <Grid item>
          <GroupIcon className={classes.icon} />
        </Grid>
        <Grid item>
          <Typography variant="subheading" lineClamp>
            {intl.formatMessage(messages.travellerInfo.travellers, {
              travellers: travellers.length,
            })}
          </Typography>
          {travellers.map((name, index) => {
            return (
              <Typography
                variant="body1"
                key={index.toString()}
                color="textSecondary"
                lineClamp
              >
                {name}
              </Typography>
            );
          })}
        </Grid>
      </Grid>
    </Paper>
  );
};

// styled
const styles = (theme: Theme) => {
  const {
    between: {
      card: { card: cardSpacing },
    },
    paper: paperSpacing,
  } = spacings(theme);
  return createStyles({
    container: {
      ...paperSpacing,
      ...cardSpacing,
    },
    icon: {
      color: theme.zeno.icons.dark.active,
    },
  });
};

const mapStateToProps = (state: AppState): StateProps => {
  return {
    travellers: getTravellerNames(state),
  };
};

const enhance = compose<TravellerInfoProps, {}>(
  pure,
  injectIntl,
  connect(mapStateToProps),
  withStyles(styles),
);

/**
 * Displays list of traveller names
 */
export const TravellerInfo = enhance(TravellerInfoBase);

TravellerInfo.displayName = 'TravellerInfo';
